// Product Comparison Functionality
let compareList = JSON.parse(sessionStorage.getItem('compareProducts') || '[]');

function addToCompare(button) {
  const productId = button.dataset.productId;
  const productData = {
    id: productId,
    title: button.dataset.productTitle,
    url: button.dataset.productUrl,
    image: button.dataset.productImage,
    price: button.dataset.productPrice,
    vendor: button.dataset.productVendor || 'N/A',
    type: button.dataset.productType || 'N/A',
    itemSpecs: button.dataset.itemSpecs || ''
  };
  
  const index = compareList.findIndex(p => p.id === productId);
  
  if (index > -1) {
    compareList.splice(index, 1);
    button.classList.remove('in-comparison');
  } else {
    if (compareList.length >= 4) {
      alert('You can only compare up to 4 products at a time.');
      return;
    }
    compareList.push(productData);
    button.classList.add('in-comparison');
  }
  
  sessionStorage.setItem('compareProducts', JSON.stringify(compareList));
  updateCompareBar();
  updateAllButtons();
}

function updateCompareBar() {
  let bar = document.getElementById('compare-bar');
  
  if (compareList.length === 0) {
    if (bar) bar.style.display = 'none';
    return;
  }
  
  if (!bar) {
    bar = document.createElement('div');
    bar.id = 'compare-bar';
    document.body.appendChild(bar);
  }
  
  bar.innerHTML = `
    <div class="compare-bar-content">
      <div class="compare-products">
        ${compareList.map(p => `
          <div class="compare-item">
            <img src="${p.image}" alt="${p.title}">
            <button onclick="removeFromCompare('${p.id}')" class="remove-btn">×</button>
          </div>
        `).join('')}
      </div>
      <button onclick="showCompareModal()" class="compare-all-btn">
        Compare All (${compareList.length})
      </button>
      <button onclick="clearComparison()" class="clear-all-btn">Clear All</button>
    </div>
  `;
  
  bar.style.display = 'block';
  bar.style.zIndex = '50';
}

function removeFromCompare(productId) {
  compareList = compareList.filter(p => p.id !== productId);
  sessionStorage.setItem('compareProducts', JSON.stringify(compareList));
  updateCompareBar();
  updateAllButtons();
}

function clearComparison() {
  compareList = [];
  sessionStorage.setItem('compareProducts', JSON.stringify(compareList));
  updateCompareBar();
  updateAllButtons();
}

function updateAllButtons() {
  document.querySelectorAll('.product-compare-btn').forEach(btn => {
    const inList = compareList.some(p => p.id === btn.dataset.productId);
    btn.classList.toggle('in-comparison', inList);
  });
}

function showCompareModal() {
  displayComparisonTable(compareList);
}

function displayComparisonTable(products) {
  let modal = document.getElementById('compare-modal');
  if (!modal) {
    modal = document.createElement('div');
    modal.id = 'compare-modal';
    document.body.appendChild(modal);
  }
  
  const productSpecs = products.map(p => extractSpecsWithOrder(p));
  const allSpecKeys = mergeSpecKeysInOrder(productSpecs);
  
  modal.innerHTML = `
    <div class="compare-modal-overlay" onclick="closeCompareModal()"></div>
    <div class="compare-modal-content">
      <div class="compare-modal-header">
        <h2>Compare Products</h2>
        <button onclick="closeCompareModal()" class="close-modal-btn">×</button>
      </div>
      
      <div class="compare-table-wrapper">
        <table class="compare-table">
          <thead>
            <tr>
              <th class="spec-label">Category</th>
              <th class="spec-label">Specification</th>
              ${products.map(p => `
                <th class="product-column">
                  <img src="${p.image}" alt="${p.title}">
                  <h3>${p.title}</h3>
                  <p class="price">${p.price}</p>
                  <a href="${p.url}" class="view-product-btn">View Product</a>
                  <button onclick="removeFromCompare('${p.id}'); closeCompareModal(); showCompareModal();" class="remove-from-compare">Remove</button>
                </th>
              `).join('')}
            </tr>
          </thead>
          <tbody>
            ${generateSpecRowsWith2Columns(productSpecs, allSpecKeys)}
          </tbody>
        </table>
      </div>
    </div>
  `;
  
  modal.style.display = 'block';
  document.body.style.overflow = 'hidden';
}

function extractSpecsWithOrder(product) {
  const specsArray = [];
  const specsMap = {};
  
  // Add basic specs first
  specsArray.push({category: 'BASIC', spec: 'Type', value: product.type, key: 'BASIC|Type'});
  specsArray.push({category: 'BASIC', spec: 'Vendor', value: product.vendor, key: 'BASIC|Vendor'});
  specsArray.push({category: 'BASIC', spec: 'Price', value: product.price, key: 'BASIC|Price'});
  
  specsMap['BASIC|Type'] = product.type;
  specsMap['BASIC|Vendor'] = product.vendor;
  specsMap['BASIC|Price'] = product.price;
  
  if (!product.itemSpecs) {
    return {array: specsArray, map: specsMap};
  }
  
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = product.itemSpecs;
  
  const rows = tempDiv.querySelectorAll('tr');
  let currentCategory = 'SPECIFICATIONS';
  
  rows.forEach((row) => {
    // Check for TH cell with red span (category header)
    const thCell = row.querySelector('th');
    if (thCell) {
      const redSpan = thCell.querySelector('span[style*="#ff0000"], span[style*="#FF0000"], span[style*="rgb(255"]');
      if (redSpan) {
        currentCategory = thCell.textContent.trim().toUpperCase();
        // DON'T return here - continue processing this row for TD cells
      }
    }
    
    // Get TD cells for spec data (even if this row also has a TH)
    const cells = row.querySelectorAll('td');
    
    if (cells.length < 2) return;
    
    const firstCell = cells[0];
    const secondCell = cells[1];
    const firstText = firstCell.textContent.trim();
    const secondText = secondCell.textContent.trim();
    
    if (!firstText || !secondText) return;
    
    // Add spec in order
    const specKey = `${currentCategory}|${firstText}`;
    specsArray.push({
      category: currentCategory,
      spec: firstText,
      value: secondText,
      key: specKey
    });
    specsMap[specKey] = secondText;
  });
  
  return {array: specsArray, map: specsMap};
}

function mergeSpecKeysInOrder(productSpecs) {
  const allKeys = [];
  const seenKeys = new Set();
  
  // Use first product as the base order
  if (productSpecs.length > 0 && productSpecs[0].array) {
    productSpecs[0].array.forEach(spec => {
      if (!seenKeys.has(spec.key)) {
        allKeys.push(spec.key);
        seenKeys.add(spec.key);
      }
    });
  }
  
  // Add any additional keys from other products (append at end of their category)
  productSpecs.forEach((productSpec, index) => {
    if (index === 0 || !productSpec.array) return;
    
    productSpec.array.forEach(spec => {
      if (!seenKeys.has(spec.key)) {
        // Find the last key with the same category and insert after it
        let insertIndex = allKeys.length;
        for (let i = allKeys.length - 1; i >= 0; i--) {
          if (allKeys[i].startsWith(spec.category + '|')) {
            insertIndex = i + 1;
            break;
          }
        }
        allKeys.splice(insertIndex, 0, spec.key);
        seenKeys.add(spec.key);
      }
    });
  });
  
  return allKeys;
}

function generateSpecRowsWith2Columns(productSpecs, specKeys) {
  let html = '';
  let lastCategory = '';
  let categoryRowspans = {};
  
  // Calculate rowspan for each category
  specKeys.forEach(key => {
    const category = key.split('|')[0];
    categoryRowspans[category] = (categoryRowspans[category] || 0) + 1;
  });
  
  specKeys.forEach(key => {
    const [category, specName] = key.split('|');
    
    html += '<tr>';
    
    // Add category cell only on first occurrence
    if (category !== lastCategory) {
      html += `<td class="category-cell" rowspan="${categoryRowspans[category]}">${category}</td>`;
      lastCategory = category;
    }
    
    // Add spec name
    html += `<td class="spec-label"><strong>${specName}</strong></td>`;
    
    // Add product values
    productSpecs.forEach(productSpec => {
      const value = productSpec.map[key] || '-';
      html += `<td>${value}</td>`;
    });
    
    html += '</tr>';
  });
  
  return html;
}

function closeCompareModal() {
  const modal = document.getElementById('compare-modal');
  if (modal) {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
  updateCompareBar();
  updateAllButtons();
});
